import { Capacitor } from '@capacitor/core';
import { AppConstants } from '../app-constants';

/**
 * One answer to "is somebody signed in on this website right now?" for every background worker (live connection, ticket badge,
 * WhatsApp approval look-up ...). On the website the session shows as a readable cookie: it is gone after a normal logout, a
 * forced logout, an expired session or before the first login, so a background call made then can only be refused with a 401.
 * The phone app keeps its cookie out of reach, so there the answer is "yes" and the server decides, as before.
 * Background code asks this BEFORE it calls; it never needs to know why the session ended.
 */
export function hasWebSession(): boolean {
  if (Capacitor.isNativePlatform() || typeof document === 'undefined') return true;
  const name = AppConstants.ENCRYPTION_KEY_COOKIE_NAME + '=';
  return document.cookie.split('; ').some((c) => c.startsWith(name));
}
